/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum AuthTypes {
    Basic = 'basic',
    Modern = 'modern',
}
